import api from "@/lib/api";

export async function findAtendentes(empresa) {
  console.log("findAtendentes called with empresa:", empresa);
  const { data } = await api.get("/auth/users", {
    params: { empresa: empresa || undefined },
  });
  return data;
}
